import React from 'react';
import {ChevronDownIcon, ChevronRightIcon, ListItem, Typography} from '@genestack/ui';
import styles from './metadata.module.css';
import {PublicationSource} from './interface';
import {DocumentSource} from './document-source';

interface Props {
    sources: PublicationSource[];
}

export function DocumentSources(props: Props) {
    const [isSourcesShown, setIsSourcesShown] = React.useState(false);

    const toggleSources = React.useCallback(() => setIsSourcesShown((prev) => !prev), []);

    if (props.sources.length === 0) {
        return (
            <ListItem>
                Source(s):{' '}
                <Typography box="inline" intent="quiet">
                    Unspecified
                </Typography>
            </ListItem>
        );
    }

    return (
        <React.Fragment>
            <ListItem onClick={toggleSources} className={styles.documentSourcesHeader}>
                {isSourcesShown ? <ChevronDownIcon /> : <ChevronRightIcon />} Source(s)
            </ListItem>

            {isSourcesShown && (
                <ol className={styles.sourcesList}>
                    {props.sources.map((source, index) => (
                        <DocumentSource source={source} key={index} />
                    ))}
                </ol>
            )}
        </React.Fragment>
    );
}
